export default function createSessionStoragePlugin() {
  return store => {
    // 从 sessionStorage 加载数据到 Vuex store
    const savedState = JSON.parse(sessionStorage.getItem('vuex'));
    if (savedState) {
      store.replaceState(Object.assign({}, store.state, savedState));
    }

    // 监听 Vuex store 的变化，并将变化后的状态保存到 sessionStorage
    store.subscribe((mutation, state) => {
      sessionStorage.setItem('vuex', JSON.stringify(state));
    });
  };
}